module.exports = __webpack_public_path__ + "img/138.3bfcff4e.png";